import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';

export interface UserInfo {
  name: string;
  email: string;
  img: string;
}

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private userSubject = new BehaviorSubject<UserInfo | null>(null);

  constructor(private authService: AuthService) {
    this.emitUserChanges();
  }

  private emitUserChanges(): void {
    const account = this.authService.getCurrentAccount();
    if (account) {
      this.userSubject.next({
        name: account.name ?? '',
        email: account.username ?? '',
        img: '../../assets/icons/navbar/nav-user-icon.svg',
      });
    } else {
      this.userSubject.next(null);
    }
  }

  getUserInfo(): Observable<UserInfo | null> {
    return this.userSubject.asObservable();
  }

  refreshUserInfo(): void {
    this.emitUserChanges();
  }

  clearUserInfo(): void {
    this.userSubject.next(null);
  }
}
